import { createAction } from '@reduxjs/toolkit'

import { PaginatedResponse } from 'api/Cerebro/types'
import {
    AsyncUpdate,
    AutomationCapability,
    BrandGroup,
    ChartColorsMap,
    Label,
    Report,
} from 'types'

export const mountAppRequest = createAction('MOUNT_APP_REQUEST')
export const mountAppSuccess = createAction('MOUNT_APP_SUCCESS')
export const mountAppFailure = createAction<unknown>('MOUNT_APP_FAILURE')

export interface AsyncReducerHydratedPayload {
    key: string
    initialState: unknown
}
export const asyncReducerHydrated = createAction<AsyncReducerHydratedPayload>(
    'ASYNC_REDUCER_HYDRATED'
)

export const changeCurrencyCode = createAction<{ currencyCode: string }>(
    'CHANGE_CURRENCY_CODE'
)
export const fetchCurrencySettingsSuccess = createAction<string | null>(
    'FETCH_CURRENCY_SETTINGS_SUCCESS'
)

export const setHiddenAutomationCapabilities = createAction<string[]>(
    'SET_HIDDEN_AUTOMATION_CAPABILITIES'
)
export const fetchHiddenAutomationCapabilities = createAction<
    string[] | undefined
>('FETCH_HIDDEN_AUTOMATION_CAPABILITIES')

export const setGlobalNotification = createAction<unknown>(
    'SET_GLOBAL_NOTIFICATION'
)

export const fetchOrganizationLabelsSuccess = createAction<
    PaginatedResponse<Label>
>('FETCH_ORGANIZATION_LABELS_SUCCESS')

export const fetchAutomationCapabilitiesSuccess = createAction<
    PaginatedResponse<AutomationCapability>
>('FETCH_AUTOMATION_CAPABILITIES_SUCCESS')

export const fetchBrandGroupsSuccess = createAction<
    PaginatedResponse<BrandGroup>
>('FETCH_BRAND_GROUPS_SUCCESS')
export const createBrandGroupSuccess = createAction<BrandGroup>(
    'CREATE_BRAND_GROUP_SUCCESS'
)
export const updateBrandGroupSuccess = createAction<BrandGroup>(
    'UPDATE_BRAND_GROUP_SUCCESS'
)
export const deleteBrandGroupSuccess = createAction<string>(
    'DELETE_BRAND_GROUP_SUCCESS'
)

export const fetchUserSurveyLastReadDateSuccess = createAction<
    string | undefined
>('FETCH_USER_SURVEY_LAST_READ_SUCCESS')
export const dismissUserSurveySuccess = createAction<string>(
    'SET_USER_SURVEY_DISMISSED_SUCCESS'
)

export const downloadReport = createAction<{ reportId: string }>(
    'DOWNLOAD_REPORT'
)

/** Register a newly started async export for the nav badge (Exports). */
export const registerNewReport = createAction<Report>('REGISTER_NEW_REPORT')

export const downloadBulkUpdate = createAction<{ id: string }>(
    'DOWNLOAD_BULK_UPDATE'
)

export const initiateUpdateSuccess = createAction<AsyncUpdate>(
    'INITIATE_UPDATE_SUCCESS'
)

export const unmountAppDrawer = createAction('UNMOUNT_APP_DRAWER')
export const toggleReportsAppDrawer = createAction<boolean>(
    'TOGGLE_REPORTS_APP_DRAWER'
)

export const fetchTriggeredAlertsForDrawerRequest = createAction(
    'FETCH_TRIGGERED_ALERTS_FOR_DRAWER_REQUEST'
)
export const fetchTriggeredAlertsForDrawerSuccess = createAction<{
    results: unknown[]
}>('FETCH_TRIGGERED_ALERTS_FOR_DRAWER_SUCCESS')
export const fetchTriggeredAlertsForDrawerFailure = createAction<unknown>(
    'FETCH_TRIGGERED_ALERTS_FOR_DRAWER_FAILURE'
)

export const toggleSidebarCollapsed = createAction('TOGGLE_SIDEBAR_COLLAPSED')

export const fetchHomeDashboardIdSuccess = createAction<string | null>(
    'FETCH_HOME_DASHBOARD_ID_SUCCESS'
)
export const setHomeDashboardId = createAction<{
    dashboardId: string | null
}>('SET_HOME_DASHBOARD_ID')

export const fetchCustomEventsSuccess = createAction<{ results: unknown[] }>(
    'FETCH_CUSTOM_EVENTS_SUCCESS'
)

export interface SovPermissions {
    read: { countries: string[]; regions: string[] }
    write: { countries: string[]; regions: string[] }
}
export const fetchSovPermissionsSuccess = createAction<SovPermissions>(
    'FETCH_SOV_PERMISSIONS_SUCCESS'
)

export const updateChartColorsMap = createAction<ChartColorsMap>(
    'UPDATE_CHART_COLORS_MAP'
)
